export const storesTranslations = {
  ar: {
    title: 'المخازن',
    addNew: 'إضافة جديد',
    name: 'الاسم',
    address: 'العنوان',
    employee: 'الموظف',
    branch: 'الفرع',
    serial: 'التسلسل',
    noStores: 'لا توجد مخازن',
    loading: 'جاري تحميل المخازن...',
    error: 'فشل تحميل المخازن',
    saveSuccess: 'تم حفظ المخزن بنجاح',
    saveError: 'فشل حفظ المخزن',
    deleteSuccess: 'تم حذف المخزن بنجاح',
    deleteError: 'فشل حذف المخزن',
    copySuccess: 'تم نسخ المخزن',
    pasteSuccess: 'تم لصق المخزن بنجاح',
    pasteError: 'لا يوجد مخزن منسوخ',
    notes: 'ملاحظات',
    selectBranch: 'اختر الفرع',
    selectEmployee: 'اختر الموظف',
    isActive: 'نشط',
    isSystem: 'نظامي',
    list: 'قائمة',
    selectStore: 'اختر المخزن',
    noStoresMatch: 'لا توجد مخازن مطابقة للبحث',
  },
  en: {
    title: 'Stores',
    addNew: 'Add New',
    name: 'Name',
    address: 'Address',
    employee: 'Employee',
    branch: 'Branch',
    serial: 'Serial',
    noStores: 'No stores',
    loading: 'Loading stores...',
    error: 'Failed to load stores',
    saveSuccess: 'Store saved successfully',
    saveError: 'Failed to save store',
    deleteSuccess: 'Store deleted successfully',
    deleteError: 'Failed to delete store',
    copySuccess: 'Store copied',
    pasteSuccess: 'Store pasted successfully',
    pasteError: 'No store copied',
    notes: 'Notes',
    selectBranch: 'Select Branch',
    selectEmployee: 'Select Employee',
    isActive: 'Active',
    isSystem: 'System',
    list: 'List',
    selectStore: 'Select Store',
    noStoresMatch: 'No stores match your search',
  },
  fr: {
    title: 'Magasins',
    addNew: 'Ajouter nouveau',
    name: 'Nom',
    address: 'Adresse',
    employee: 'Employé',
    branch: 'Succursale',
    serial: 'Série',
    noStores: 'Aucun magasin',
    loading: 'Chargement des magasins...',
    error: 'Échec du chargement des magasins',
    saveSuccess: 'Magasin enregistré avec succès',
    saveError: 'Échec de l\'enregistrement du magasin',
    deleteSuccess: 'Magasin supprimé avec succès',
    deleteError: 'Échec de la suppression du magasin',
    copySuccess: 'Magasin copié',
    pasteSuccess: 'Magasin collé avec succès',
    pasteError: 'Aucun magasin copié',
    notes: 'Notes',
    selectBranch: 'Sélectionner la succursale',
    selectEmployee: 'Sélectionner l\'employé',
    isActive: 'Actif',
    isSystem: 'Système',
    list: 'Liste',
  },
}


